import Vue from 'vue'
import Router from 'vue-router'
import store from '@/vuex'
import Login from '@/views/Login.vue'
import PasswordReset from '@/views/PasswordReset.vue'
import Profile from '@/views/Profile.vue'
import UserAdmin from '@/views/UserAdmin.vue'
import Vessels from '@/views/Vessels.vue'
import Vessel from '@/views/Vessel.vue'
import VesselTrials from '@/views/VesselTrials.vue'
import VesselMachines from '@/views/VesselMachines.vue'
import VesselCrew from '@/views/VesselCrew.vue'
import VesselMachine from '@/views/VesselMachine.vue'
import VesselTrial from '@/views/VesselTrial.vue'
import VesselTrialTest from '@/views/VesselTrialTest.vue'
import PdfTrialExport from '@/views/PdfTrialExport.vue'

Vue.use(Router)

const router = new Router({
  hash: false,
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false, title: 'Marex Solutions - Login' }
    },
    {
      path: '/',
      name: 'home',
      component: Vessels,
      meta: { requiresAuth: true, title: 'Vessels' }
    },
    {
      path: '/password-reset/:id',
      name: 'passwordReset',
      component: PasswordReset,
      props: true,
      meta: { requiresAuth: false, title: 'Reset Password' }
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: { requiresAuth: true, title: 'Profile' }
    },
    {
      path: '/user-admin',
      name: 'userAdmin',
      component: UserAdmin,
      meta: { requiresAuth: true, title: 'User Admin' }
    },
    {
      path: '/vessel/:id',
      name: 'vessel',
      props: true,
      component: Vessel,
      meta: { requiresAuth: true, title: 'Vessel', navbarTabs: true },
      children: [
        {
          path: 'details',
          name: 'vesselDetails',
          component: () => import('@/views/VesselDetails.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'trials',
          name: 'vesselTrials',
          component: VesselTrials,
          meta: { requiresAuth: true }
        },
        {
          path: 'machines',
          name: 'vesselMachines',
          component: VesselMachines,
          meta: { requiresAuth: true }
        },
        {
          path: 'crew',
          name: 'vesselCrew',
          component: VesselCrew,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/vessel-machine/:id',
      name: 'vesselMachine',
      props: true,
      component: VesselMachine,
      meta: { requiresAuth: true, title: 'Vessel Machine' }
    },
    {
      path: '/vessel-trial/:id',
      name: 'vesselTrial',
      props: true,
      component: VesselTrial,
      meta: { requiresAuth: true, title: 'Vessel Trial', navbarTabs: true },
      children: [
        {
          path: 'details',
          name: 'vesselTrialDetails',
          component: () => import('@/views/VesselTrialDetails.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'tests',
          name: 'vesselTrialTests',
          component: () => import('@/views/VesselTrialTests.vue'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/vessel-trial-test/:id',
      name: 'vesselTrialTest',
      props: true,
      component: VesselTrialTest,
      meta: { requiresAuth: true, title: 'Vessel Trial Test' }
    },
    {
      path: '/pdf-trial-export/:id',
      name: 'pdfTrialExport',
      props: true,
      component: PdfTrialExport,
      meta: { requiresAuth: true, title: 'Vessel Trial Export' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    store.dispatch('setPageTitle', '')
    document.title = to.meta.title
  }

  const user = localStorage.getItem('user')

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // route requires auth, check if logged in
    // if not, redirect to login page
    if (!user) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    // route does not require auth, check if logged in
    // if so, redirect to home page
    if (user) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  }
})

export default router
